import { FunctionComponent } from 'react';
import { TypeInfoArrowTextProps } from './types';
import { UnderlineTag } from '@/atoms';
import ArrowText from '@/atoms/arrow-text';

/**
 * Arrow Text
 */
export const InfoArrowText: FunctionComponent<TypeInfoArrowTextProps> = ({
  className,
  subtitle,
  arrowsTitles,
  textInfo,
}: TypeInfoArrowTextProps) => (
  <div className={className}>
    <UnderlineTag position="left" theme="light">
      {subtitle}
    </UnderlineTag>

    <div className="w-full  flex justify-between mt-10 flex-col lg:flex-row">
      <div className="pr-6">
        {arrowsTitles.map((arrow, index: number) => (
          <ArrowText
            key={arrow.id ?? index}
            labelArrow={arrow.title}
            className="pb-6"
          />
        ))}
      </div>
      <div className="text-primary-600 text-subtitle text-subtitle--m ">
        <p>{textInfo}</p>
      </div>
    </div>
  </div>
);

InfoArrowText.displayName = 'InfoArrowText';
